<div
  class="tlh-card"
  [class.tlh-card--urgent]="isUrgent"
  (click)="cardClick.emit($event)"
  (contextmenu)="onContextMenu($event)">
  <div class="tlh-card__header">
    <span class="tlh-card__number">
      #{{ ticket.ticket_number_teorema }}
      @if (isUrgent) {
        <i
          class="bi bi-exclamation-triangle-fill tlh-card__alert-icon tlh-card__alert-icon--red"
          title="Urgente"></i>
      }
      @if (hasFailedTest) {
        <i
          class="bi bi-x-octagon-fill tlh-card__alert-icon tlh-card__alert-icon--red"
          title="Teste não ok"></i>
      }
      @if (isPendingRelease) {
        <i
          class="pi pi-lock tlh-card__alert-icon tlh-card__alert-icon--blue"
          title="Liberação pendente"></i>
      }
      @if (isDefect) {
        <i
          class="bi bi-bug-fill tlh-card__alert-icon tlh-card__alert-icon--red"
          title="Defeito/Retrabalho"></i>
      }
    </span>
    @if (status) {
      <span class="tlh-card__status" [style.background]="statusColor">{{ status }}</span>
    }
  </div>

  <div class="tlh-card__customer">
    {{ customer }}
    @if (system) {
      <span class="tlh-card__system-badge"> &bull; {{ system }}</span>
    }
  </div>

  @if (summary) {
    <div class="tlh-card__summary">{{ summary }}</div>
  }

  @if (tags.length > 0) {
    <div class="tlh-card__tags">
      @for (tag of tags; track tag) {
        <span class="tlh-card__tag-badge">{{ tag }}</span>
      }
    </div>
  }

  <!-- A tela projeta aqui o total do dia, o botão de expandir e a lista de
       apontamentos. É o slot que o card da sprint não tem. -->
  <ng-content></ng-content>
</div>
